<template>
  <div class="row">
    <div class="col-md-12">
      <template v-for="action in actions">
        <check-permission
          v-if="checkModule(action) && checkCreator(action)"
          :key="`action_${object.id}_${action.id || action.event}`"
          :entity-id="action.entityId ? action.entityId : object.id"
          :entity-type="action.entityType ? action.entityType : entityType"
          :permissions="action.permissions ? action.permissions : getPermissions(action.permissionTypes)"
        >
          <check-permission
            v-if="action.creatorOnly === false && entityType === 'document' && action.id"
            join-type="OR"
            :permissions="nonAuthorPermissions"
          >
            <w-button
              class="btn-light mr-2 mb-1"
              :class="action.class"
              :icon="action.icon"
              :text="action.tooltipText || action.name"
              :style="{ color: actionColor(action) }"
              @click="$emit(action.event, { object, action })"
            />
          </check-permission>

          <w-button
            v-else
            class="btn-light mr-2 mb-1"
            :class="action.class"
            :icon="action.icon"
            :text="action.tooltipText || action.name"
            :style="{ color: actionColor(action) }"
            @click="$emit(action.event, { object, action })"
          />
        </check-permission>
      </template>
    </div>
  </div>
</template>

<script>
import { actionsMixin } from '@/mixins/actions';

// @vuese
// Akcje dokumentu
// @group Components
export default {
  name: 'Actions',
  mixins: [actionsMixin],
  computed: {
    // @vuese
    // Encja struktury
    secretaryEntity() {
      const nodeId = this.object?.data?.school?.nodeId;
      if (nodeId) {
        return `structure_node:${nodeId}`;
      }
    },

    // @vuese
    // Encja procedury
    operatorEntity() {
      const procedureId = this.object?.procedureId;
      if (procedureId) {
        return `procedure:${procedureId}`;
      }
    },

    // @vuese
    // Uprawnienia do przycisku nie dla autora
    nonAuthorPermissions() {
      const entities = [this.secretaryEntity, this.operatorEntity];
      return entities.filter(Boolean).map(entity => `BUTTON.USE:${entity}`);
    }
  }
};
</script>
